import React from "react";
import { useNavigate } from "react-router-dom";

export default function PolicyReviewsMenu() {
  const navigate = useNavigate();

  return (
    <div className="pageWrapper">
      <div className="compact-hero">
        <h1 className="pageTitle">Policy Reviews</h1>
        <p
          style={{
            margin: "10px 0 0",
            color: "rgba(255,255,255,0.82)",
            lineHeight: 1.7,
          }}
        >
          Start a new review cycle or reopen historical reviews from a cleaner
          policy review workspace.
        </p>
      </div>

      <div className="menuContainer" style={{ marginTop: "18px" }}>
        <div
          className="menuCard"
          onClick={() => navigate("/policy-reviews/new")}
          style={{ background: "linear-gradient(135deg, #102a71, #2053c3)" }}
        >
          <h3>Start ISO Policy Review</h3>
          <p>Start a structured periodic review for a policy or document.</p>
        </div>

        <div
          className="menuCard"
          onClick={() => navigate("/policy-reviews/list")}
          style={{ background: "linear-gradient(135deg, #17388f, #2f6fe4)" }}
        >
          <h3>View Previous Reviews</h3>
          <p>Browse, search, and reopen the policy reviews already completed.</p>
        </div>
      </div>

      <style>{`
        .pageWrapper {
          min-height: 100vh;
          padding-top: 24px;
        }

        .pageTitle {
          color: #fff;
          margin-bottom: 0;
        }

        .menuCard {
          padding: 24px;
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }

        .menuCard:hover {
          transform: translateY(-6px);
        }

        .menuCard h3 {
          margin-bottom: 10px;
          font-size: 20px;
          font-weight: 600;
          color: #fff;
        }

        .menuCard p {
          margin: 0;
          color: rgba(255,255,255,0.86);
          font-size: 14px;
        }
      `}</style>
    </div>
  );
}
